module.exports = __webpack_public_path__ + "img/SES_4110080300.ac5f96c2.jpg";